import { PRODUCT_STATUS } from 'types/products';
import './ProductStatusTabs.scss';

export type TProductStatus = PRODUCT_STATUS;

interface IProductStatusTabsProps {
  currentStatus: TProductStatus;
  onStatusChange: (newStatus: TProductStatus, previousStatus: TProductStatus) => void;
  customClassName?: string;
}

interface IStatusOption {
  key: TProductStatus;
  label: string;
}

const STATUS_OPTIONS: IStatusOption[] = [
  { key: PRODUCT_STATUS.ON, label: PRODUCT_STATUS.ON },
  { key: PRODUCT_STATUS.TO_QUOTE, label: PRODUCT_STATUS.TO_QUOTE },
  { key: PRODUCT_STATUS.OFF, label: PRODUCT_STATUS.OFF }
];

const ProductStatusTabs = ({ currentStatus, onStatusChange, customClassName = '' }: IProductStatusTabsProps) => {
  const handleStatusClick = (status: TProductStatus) => {
    if (status === currentStatus) return;
    const previousStatus = currentStatus;
    onStatusChange(status, previousStatus);
  };

  return (
    <div className={`productStatusTabs ${customClassName}`}>
      {STATUS_OPTIONS.map(option => {
        const isActive = option?.key === currentStatus;
        return (
          <div
            key={option?.key}
            className={`statusTab ${isActive ? 'activeStatus' : 'inactiveStatus'}`}
            onClick={() => handleStatusClick(option?.key)}
          >
            {option?.label}
          </div>
        );
      })}
    </div>
  );
};

export default ProductStatusTabs;
